import React, { useState, useEffect } from "react";
import backgroundImage from "../Assert/Image/background.jpg";
import logo from "../Assert/Newlogo/PemixcelsLogo.png";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import BELL from "../Assert/Image/announcement-bell.png";
import { BsBellFill, BsArrowRight } from "react-icons/bs";
import { FaEnvelope } from "react-icons/fa";

export default function ComingSoonPage() {
  const [showModal, setShowModal] = useState(false);
  const [showOffCanvas, setShowOffCanvas] = useState(false);
  // const [email, setEmail] = useState("");

  useEffect(() => {
    document.body.style.overflow = showModal || showOffCanvas ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [showModal, showOffCanvas]);

  // const handleSubscribe = async (e) => {
  //   e.preventDefault();

  //   const formData = new FormData();
  //   formData.append("email", email);

  //   try {
  //     const response = await fetch("http://localhost:5890/api/subscribe", {
  //       method: "POST",
  //       body: formData,
  //     });

  //     const data = await response.json();

  //     if (data.success) {
  //     toast.success(data.message);
  //       setEmail("");
  //       setShowModal(false);
  //     } else {
  //     toast.error(data.message || "Subscription failed.");
  //     }
  //   } catch (error) {
  //     console.error("Subscription error:", error);
  //   toast.error("Something went wrong. Please try again later.");
  //   }
  // };

  return (
    <div
      className="coming-soon-area position-relative d-flex align-items-center justify-content-center"
  
      style={{
        height: "100vh",
        width: "100vw",
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        overflow: "hidden",
        
      }}
    >
          <ToastContainer position="top-right" autoClose={3000} />

     <div
  className="position-absolute top-0 start-0 w-100 h-100"
  style={{
    zIndex: 0,
    background: "linear-gradient(to right, #ffffff, transparent)",
  }}
></div>

      <div className="container position-relative z-1 coming-soon-content text-center text-sm-start">
        <div className="row align-items-center">
          <div className="col-12 col-md-6 mb-4 mb-md-0">
<img src={logo} alt="Company Logo" style={{ width: "100%", height: '100%' }} />
       <h5 className="text-black mt-3" style={{ fontFamily: 'Roboto, sans-serif', fontWeight: 500 }}>
  We're Coming Soon...
</h5><h1
  className="mb-4"
style={{
  fontFamily: "'Roboto', sans-serif",
  fontWeight: 800,
  fontSize: '3rem',
  lineHeight: 1.2,
  letterSpacing: '-0.02em',
  color: '#2f373e',
}}

>
  Internationally Acclaimed Web Design Company from India
</h1>


<p
  style={{
    fontFamily: 'Roboto, sans-serif',
    fontWeight: 900, // max valid weight
    fontSize: '1.125rem',
    lineHeight: '1.6',
    color: 'rgba(255, 255, 255, 0.85)',
    textShadow: '0 1px 3px rgba(0, 0, 0, 0.3)',
    maxWidth: '600px',
  }}
>
  Stay connected with us while we craft a digital masterpiece.
</p>


            <div className="btn-box d-flex flex-wrap gap-3 mt-4 justify-content-center justify-content-sm-start">
              <button
                onClick={() => setShowModal(true)}
                className="btn btn-success d-flex align-items-center gap-2 px-3 py-2 shadow rounded-pill"
              >
                GET NOTIFIED
                <span className="btn-icon d-flex px-1 py-1 align-items-center justify-content-center rounded-circle bg-white text-success">
                  <BsBellFill size={16} />
                </span>
              </button>

              <button
                onClick={() => setShowOffCanvas(true)}
                className="btn btn-warning d-flex align-items-center gap-2 px-4 py-2 shadow rounded-pill"
              >
                GET MORE INFO
                <span className="btn-icon d-flex  px-1 py-1 align-items-center justify-content-center rounded-circle bg-white text-warning">
                  <BsArrowRight size={16} />
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Newsletter Modal */}
      {showModal && (
     <div
  className="subscribe-modal active"
  style={{
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1050,
    animation: "fadeIn 0.5s ease-out",
  }}
  onClick={() => setShowModal(false)}
>
  <div
    className="subscribe-modal-inner"
    onClick={(e) => e.stopPropagation()}
    style={{
      background: "#fff",
      padding: "2rem",
      borderRadius: "1rem",
      width: "90%",
      maxWidth: "900px",
      boxShadow: "0 10px 25px rgba(0, 0, 0, 0.2)",
      position: "relative",
      animation: "scaleUp 0.5s ease-out",
      textAlign: "center",
    }}
  >
    <div
      className="newsletter-header mb-4 position-relative"
      style={{ height: "120px" }}
    >
        {[...Array(11)].map((_, i) => {
          const isMobile = window.innerWidth <= 576;

          const positionStyle = i < 6
            ? isMobile
              ? {
                  left: `${[10, 20, 30, 40, 25, 35][i]}%`,
                  top: `${[10, 20, 15, 5, 25, 30][i]}%`,
                }
              : {
                  left: `${[2, 5, 7, 7, 4, 7][i]}vw`,
                  top: `${[4, 4, 4, 1, 2, 4][i]}vw`,
                }
            : isMobile
            ? {
                right: `${[10, 20, 30, 15, 25, 35][i - 6]}%`,
                top: `${[10, 5, 20, 25, 15, 30][i - 6]}%`,
              }
            : {
                right: `${[2, 5, 7, 10, 8, 6][i - 6]}vw`,
                top: `${[4, 2, 2, 1, 5, 4][i - 6]}vw`,
              };

          return (
            <FaEnvelope
              key={`icon-${i}`}
              className="animate-icon"
              style={{
                ...positionStyle,
                position: "absolute",
                color: "#ff5722",
                opacity: 0, // Start invisible
                visibility: "visible",
                transform: "scale(0)", // Start scaled down
                animation: `flowIn 1.2s ease-in-out ${i * 0.1}s forwards`, // Fluid entrance with scale
              }}
              size={20}
              onAnimationStart={() => {
                const audio = new Audio('path-to-sound-file.mp3');
                audio.play(); // Play sound when animation starts
              }}
            />
          );
        })}
      <img
        src={BELL}
        alt="Bell Icon"
        style={{
          width: 60,
          height: 60,
          position: "absolute",
          left: "50%",
          top: "50%",
          transform: "translate(-50%, -50%)",
          animation: "pulse 2s infinite",
        }}
      />
    </div>

    <h2 className="mb-3 fw-bold" style={{ color: "#333" }}>
      Subscribe Newsletter
    </h2>
    <p className="mb-4" style={{ color: "#666", fontSize: "0.95rem" }}>
      Being the first to know always feels great. Signing up to our newsletter
      gives you exclusive access to our Grand Opening!
    </p>

    <div id="mc_embed_shell">
          <link
            href="//cdn-images.mailchimp.com/embedcode/classic-061523.css"
            rel="stylesheet"
            type="text/css"
          />
          <style>{`
            #mc_embed_signup {
              background: #fff;
              clear: left;
              font: 14px Helvetica, Arial, sans-serif;
              width: 100%;
              max-width: 600px;
              margin: 0 auto;
            }
          `}</style>

          <div id="mc_embed_signup">
            <form
              action="https://pemixcels.us8.list-manage.com/subscribe/post?u=bb2620d84b972f1115ea41d71&amp;id=01674a417c&amp;f_id=005929e3f0"
              method="post"
              id="mc-embedded-subscribe-form"
              name="mc-embedded-subscribe-form"
              className="validate"
              target="_blank"
              noValidate
            >
              <div id="mc_embed_signup_scroll">
                
                <div className="indicates-required">
                </div>
                <div className="mc-field-group">
                  <label htmlFor="mce-EMAIL">
                    Email Address <span className="asterisk">*</span>
                  </label>
            
            <input
  type="email"
  name="EMAIL"
  className="required email"
  id="mce-EMAIL"
  required
  defaultValue=""
  placeholder="Enter your email"
  style={{
    padding: '10px 14px',
    border: '2px solid #FFA500',         // Orange border
    borderRadius: '8px',                 // More modern rounded corners
    fontSize: '16px',
    outline: 'none',
    width: '100%',                       // Responsive width
    maxWidth: '400px',
    boxSizing: 'border-box',
    transition: 'border-color 0.3s ease',
  }}
  onFocus={(e) => (e.target.style.borderColor = '#FF8C00')}  // Slightly darker orange on focus
  onBlur={(e) => (e.target.style.borderColor = '#FFA500')}
/>


                </div>
                <div id="mce-responses" className="clear foot">
                  <div
                    className="response"
                    id="mce-error-response"
                    style={{ display: "none" }}
                  ></div>
                  <div
                    className="response"
                    id="mce-success-response"
                    style={{ display: "none" }}
                  ></div>
                </div>

                <div
                  style={{ position: "absolute", left: "-5000px" }}
                  aria-hidden="true"
                >
                  <input
                    type="text"
                    name="b_bb2620d84b972f1115ea41d71_01674a417c"
                    tabIndex={-1}
                    defaultValue=""
                  />
                </div>

                <div className="optionalParent">
                  <div className="clear foot">
                    <input
                      type="submit"
                      name="subscribe"
                      id="mc-embedded-subscribe"
                      className="button"
                      value="Subscribe"
                    />
                    <p style={{ margin: "0px auto" }}>
                      <a
                        href="http://eepurl.com/jf2SW-"
                        title="Mailchimp - email marketing made easy and fun"
                      >
                        <span
                          style={{
                            display: "inline-block",
                            backgroundColor: "transparent",
                            borderRadius: "4px",
                          }}
                        >
                          <img
                            className="refferal_badge"
                            src="https://digitalasset.intuit.com/render/content/dam/intuit/mc-fe/en_us/images/intuit-mc-rewards-text-dark.svg"
                            alt="Intuit Mailchimp"
                            style={{
                              width: 220,
                              height: 40,
                              display: "flex",
                              padding: "2px 0px",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          />
                        </span>
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <script
            type="text/javascript"
            src="//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js"
          ></script>
          <script
            dangerouslySetInnerHTML={{
              __html: `(function($) {
                window.fnames = new Array();
                window.ftypes = new Array();
                fnames[0]='EMAIL';ftypes[0]='email';
                fnames[1]='FNAME';ftypes[1]='text';
                fnames[2]='LNAME';ftypes[2]='text';
                fnames[3]='ADDRESS';ftypes[3]='address';
                fnames[4]='PHONE';ftypes[4]='phone';
                fnames[5]='BIRTHDAY';ftypes[5]='birthday';
              }(jQuery));
              var $mcj = jQuery.noConflict(true);`,
            }}
          />
        </div>
  </div>
</div>

     )}

     
     {showOffCanvas && (
  <>
    <div
      className="offcanvas offcanvas-end show"
      tabIndex="-1"
      style={{
        visibility: "visible",
        position: "fixed",
        top: 0,
        right: 0,
        height: "100%",
        width: "550px",
        backgroundColor: "#fff",
        zIndex: 1051,
        padding: "1rem",
        boxShadow: "-2px 0 10px rgba(0, 0, 0, 0.2)",
        transition: "transform 0.3s ease-in-out",
      }}
    >
     <div className="offcanvas-header d-flex justify-content-between align-items-center">
  <h5
    style={{
      marginBottom: 0,
      fontSize: "25px",
      fontWeight: 1000,
      fontFamily: "'Dosis', sans-serif"
    }}
  >
    About Us
  </h5>
  <button
    type="button"
    className="btn-close text-reset"
    onClick={() => setShowOffCanvas(false)}
  ></button>
</div>


      <div className="offcanvas-body">
        <div className="sidebar-modal about-area">
          <p>
            With our diverse technical expertise, Pe Mixcels – The Best Web
            Design Company in India strives to deliver world-class business
            solutions to clients hailing from varied industries. Over the years,
            we’ve successfully launched & improved 750’s of project’s for our
            clients across the globe. We provide innovative business solutions
            that drive our clients towards their business goals and objectives.
          </p>

          <h4 className="mt-4"  style={{
      marginBottom: 0,
      fontSize: "25px",
      fontWeight: 1000,
      fontFamily: "'Dosis', sans-serif"
    }}>Contact Us by Whatsapp</h4>
    <form
      className="contact-form mt-3"
      onSubmit={async (e) => {
        e.preventDefault();

        const formData = new FormData();
        formData.append('name', e.target.name.value);
        formData.append('mobile', e.target.mobile.value);
        formData.append('email', e.target.email.value);
        formData.append('message', e.target.message.value);

        try {
          const response = await fetch('http://localhost:5890/api/contact', {
            method: 'POST',
            body: formData,
          });

          const data = await response.json();
          if (data.success) {
      toast.success(data.message);
            e.target.reset();
          } else {
            toast.error(data.message || 'Submission failed.');
          }
        } catch (error) {
          console.error('Submission error:', error);
          toast.error('Something went wrong. Please try again later.');
        }
      }}
    >
      <input
        type="text"
        name="name"
        placeholder="Name"
        className="form-control mb-3"
        required
      />
      <input
        type="text"
        name="mobile"
        placeholder="Mobile Number"
        className="form-control mb-3"
        required
      />
      <input
        type="email"
        name="email"
        placeholder="Email"
        className="form-control mb-3"
        required
      />
      <textarea
        name="message"
        placeholder="Your Message"
        className="form-control mb-3"
        rows="4"
        required
      ></textarea>
      <button
        type="submit"
        className="btn btn-dark px-4 py-2"
        style={{ borderRadius: '25px' }}
      >
        Send Message
      </button>
    </form>
          <div style={{ textAlign: 'center', fontFamily: "'Dosis', sans-serif", padding: '20px' }}>
      <h3 style={{ fontSize: '22px', fontWeight: 700, marginBottom: '20px' }}>
        Contact us by Phone Number or Email Address
      </h3>

      <h2 style={{ fontSize: '28px', fontWeight: 700, color: '#2e7d32', margin: 0 }}>
        <a href="tel:+919003874441" style={{ color: '#2e7d32', textDecoration: 'none' }}>
          +91 900 387 4441
        </a>
      </h2>

      <div style={{ margin: '10px 0', color: '#7a7a7a', fontWeight: 500, letterSpacing: '1px' }}>OR</div>

      <h2 style={{ fontSize: '26px', fontWeight: 700, margin: 0 }}>
        <a href="mailto:reach@pemixcels.com" style={{ color: '#000', textDecoration: 'none' }}>
          reach@pemixcels.com
        </a>
      </h2>
    </div>
        </div>
      </div>
    </div>
  


    <div
      className="offcanvas-backdrop fade show"
      onClick={() => setShowOffCanvas(false)}
      style={{
        position: "fixed",
        top: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: 1050,
      }}
    ></div>
  </>
)}


    </div>
  );
}